export default __webpack_public_path__ + "static/media/Icon1.34c7b485.svg";